import { JsonProperty, Serializable } from "@anna-money/anna-web-lib/serializerOld";
import { CompanyProduct } from "services/companyProducts/companyProductsTypes";

export enum PricingPlan {
  JustRegister = "just_register",
  JustRegister2026 = "just_register_2026",
  LaunchPack = "launch_pack",
  FullFormation = "full_formation", // deprecated
  FullFormation19 = "full_formation_19",
  BusinessSecretary = "business_secretary",
  BusinessEssentials = "business_essentials",
  AllInOne = "all_on_one",
  Privacy = "privacy",
  SecretaryMonthly2025 = "secretary_monthly_2025",
  SecretaryYearly2025 = "secretary_yearly_2025",
  SecretaryPlusMonthly2025 = "secretary_plus_monthly_2025",
  SecretaryPlusYearly2025 = "secretary_plus_yearly_2025",
  TotalSupportMonthly2025 = "total_support_monthly_2025",
  TotalSupportYearly2025 = "total_support_yearly_2025",
  BusinessSupportYearly2026 = "business_support_yearly_2026",
  TotalSupportYearly2026 = "total_support_yearly_2026",
  BlackFriday2025 = "black_friday_2025",
  BusinessLaunch2026 = "business_launch_2026",
  BusinessLaunchChFee2026 = "business_launch_ch_fee_2026",
  BusinessSupportChFeeYearly2026 = "business_support_ch_fee_yearly_2026",
  TotalSupportChFeeYearly2026 = "total_support_ch_fee_yearly_2026",
  SecretaryLite2026 = "secretary_lite_2026",
  SecretaryYearly2026 = "secretary_yearly_2026",
  IntroducerFreeRegistration = "introducer_free_registration",
  Unknown = "UNKNOWN", // Treat as null - customer needs to select a plan

  // AU
  EasyCompany = "easy_company",
  EasyCompanyCashback = "easy_company_cashback",
  SoleTraderLaunch = "sole_trader_launch",
}

export type PricingPlanGb =
  | PricingPlan.JustRegister
  | PricingPlan.JustRegister2026
  | PricingPlan.LaunchPack
  | PricingPlan.FullFormation19
  | PricingPlan.FullFormation
  | PricingPlan.BusinessSecretary
  | PricingPlan.BusinessEssentials
  | PricingPlan.Privacy
  | PricingPlan.SecretaryMonthly2025
  | PricingPlan.SecretaryYearly2025
  | PricingPlan.SecretaryPlusMonthly2025
  | PricingPlan.SecretaryPlusYearly2025
  | PricingPlan.TotalSupportMonthly2025
  | PricingPlan.TotalSupportYearly2025
  | PricingPlan.BlackFriday2025
  | PricingPlan.BusinessSupportYearly2026
  | PricingPlan.TotalSupportYearly2026
  | PricingPlan.BusinessLaunch2026
  | PricingPlan.BusinessLaunchChFee2026
  | PricingPlan.BusinessSupportChFeeYearly2026
  | PricingPlan.TotalSupportChFeeYearly2026
  | PricingPlan.SecretaryLite2026
  | PricingPlan.SecretaryYearly2026
  | PricingPlan.IntroducerFreeRegistration
  | PricingPlan.AllInOne;

export type PricingPlanAu = PricingPlan.EasyCompany | PricingPlan.EasyCompanyCashback | PricingPlan.SoleTraderLaunch;

export type PricingPlanProducts = Record<PricingPlan, CompanyProduct[]>;

@Serializable()
export class PricingPlansProductsData {
  constructor(@JsonProperty({ type: Object }) readonly products: PricingPlanProducts) {}
}
